import { defineStore } from 'pinia'

const DEFAULT_TIMEOUT = 3000 // Default hide timeout in ms
const ANIMATION_TIMEOUT = 250 // CSS Animation time (to control element display)

// ToDo: Setup alert colors (success, error...)
export const useAlert = defineStore('alert', {
  state: () => ({
    active: false,
    hidden: true,
    text: '',
    type: '',
    title: '',
  }),
  actions: {
    show({ text, timeout, type, title }) {
      // Show the element
      this.hidden = false

      // And set the alert active in new tread to ensure animation show
      setTimeout(() => {
        this.text = text
        this.active = true
        this.type = type
        this.title = title
      }, 0)

      // Close timeout
      let timeoutValue = timeout
      if (typeof timeoutValue !== 'number') {
        timeoutValue = DEFAULT_TIMEOUT
      }
      setTimeout(() => {
        this.hide()
      }, timeoutValue)
    },
    hide() {
      this.active = false
      this.text = ''

      setTimeout(() => {
        this.hidden = true
      }, ANIMATION_TIMEOUT)
    },
  },
})
